import { PlayerBetIcon } from '@/components/common/betArea/svg';
import { RwdSvgIcon } from '@/components/common/rwdSvgIcon/RwdSvgIcon';
import { useIsLobby } from '@/hooks/useIsLobby';
import { getPlayerCount } from '@/modules/count/slice';
import { getHostById } from '@/modules/host/slice';
import { PlayerCountIcon } from '@/modules/lobby/svg';
import { getMainUserState } from '@/modules/main/selector';
import { RwdSvgIcon as NewRwdSvgIcon } from '@/modules/rwdGame/components/RwdSvgIcon/RwdSvgIcon';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import { getTotalBets } from '@/modules/totalBet/slice';
import { RootState } from '@/store/store';
import {
    ExchangeBetAmount,
    getVHByRem,
    numberFormat,
} from '@/utils/commonFunc';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './PlayerCount.scss';

type PlayerCountProps = {
    hostId: number;
    showBet?: boolean;
};

export const PlayerCount = ({ hostId, showBet }: PlayerCountProps) => {
    const { ExchangeRate } = useSelector(getMainUserState);
    const { IsRest } = useSelector((state: RootState) =>
        getHostById(state, hostId)
    );
    const { TotalBet } = useSelector((state: RootState) =>
        getTotalBets(state, hostId)
    );
    const countState = useSelector((state: RootState) =>
        getPlayerCount(state, hostId)
    );
    const [count, setCount] = useState(0);
    const [betCount, setBetCount] = useState(0);
    const [dummyStr, setDummyStr] = useState('0');
    useEffect(() => {
        if (countState) setCount(countState.Count);
        if (countState && countState.Count && !IsRest) {
            const numStr = ''
                .padStart(countState.Count.toString().length, '0')
                .replace(/\d(?=(\d{3})+(?!\d))/g, '$&,');
            setDummyStr(numStr);
        } else {
            setCount(0);
            setDummyStr('0');
        }
    }, [countState, IsRest]);
    useEffect(() => {
        if (showBet && TotalBet && TotalBet.Total) {
            setBetCount(
                ExchangeBetAmount(TotalBet.Total.Amount, ExchangeRate) / 100
            );
        } else {
            setBetCount(0);
        }
    }, [showBet, TotalBet]);

    const isLobby = useIsLobby();

    return (
        <>
            {isLobby && (
                <Stack direction="row" alignItems="center" gap={'0.7rem'}>
                    <Stack direction="row" alignItems="center" gap={'0.25rem'}>
                        {showBet && (
                            <RwdSvgIcon vSize={0.8} hSize={getVHByRem(0.8)}>
                                <PlayerBetIcon width={'100%'} height={'100%'} />
                            </RwdSvgIcon>
                        )}
                        {showBet && (
                            <Typography className="my-font-14">
                                {numberFormat(betCount, 0)}
                            </Typography>
                        )}
                    </Stack>
                    <Stack direction="row" alignItems="center" gap={'0.25rem'}>
                        <RwdSvgIcon vSize={0.8} hSize={getVHByRem(0.8)}>
                            <PlayerCountIcon width={'100%'} height={'100%'} />
                        </RwdSvgIcon>

                        <Typography className="space-holder my-font-14">
                            {dummyStr}
                        </Typography>
                        <Typography className="player-count-class my-font-14">
                            {numberFormat(count, 0)}
                        </Typography>
                    </Stack>
                </Stack>
            )}
            {!isLobby && (
                <Box className="in-game-player-count-container">
                    {showBet && (
                        <>
                            <NewRwdSvgIcon
                                portraitIconSize={16}
                                landscapeIconSize={32}
                            >
                                <PlayerBetIcon />
                            </NewRwdSvgIcon>
                            <RwdTypography stepIndex={0} landscapeStepIndex={3}>
                                {numberFormat(betCount, 0)}
                            </RwdTypography>
                        </>
                    )}
                    <>
                        <NewRwdSvgIcon
                            portraitIconSize={16}
                            landscapeIconSize={32}
                        >
                            <PlayerCountIcon />
                        </NewRwdSvgIcon>
                        <Box className="counter-container">
                            <RwdTypography
                                stepIndex={0}
                                landscapeStepIndex={3}
                                className="space-holder"
                            >
                                {dummyStr}
                            </RwdTypography>
                            <RwdTypography
                                stepIndex={0}
                                landscapeStepIndex={3}
                                className="counter-value"
                            >
                                {numberFormat(count, 0)}
                            </RwdTypography>
                        </Box>
                    </>
                </Box>
            )}
        </>
    );
};

export const FooterPlayerCount = ({ hostId }: PlayerCountProps) => {
    const countState = useSelector((state: RootState) =>
        getPlayerCount(state, hostId)
    );
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (countState) setCount(countState.Count);
    }, [countState]);
    return (
        <Stack direction="row" alignItems="center" gap={'0.3rem'}>
            <NewRwdSvgIcon portraitIconSize={14} landscapeIconSize={32}>
                <PlayerCountIcon className="multibet-player-count" />
            </NewRwdSvgIcon>
            <RwdTypography stepIndex={-1} landscapeStepIndex={3}>
                {numberFormat(count, 0)}
            </RwdTypography>
        </Stack>
    );
};
